import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgColor?: string;
  $textColor?: string;
  $colorType?: 'black';
}

export const PaymentBenefitItem = styled.div<IProps>`
  width: 100%;

  .btn {
    position: relative;
    width: 100%;
    height: 124px;
    background: ${props =>
      props.$colorType === 'black' ? '#1a1a1a' : props.$bgColor || '#f6f6f6'};
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 14px 16px;
    text-align: left;
  }

  .card-img {
    width: 15px;
    min-height: 15px;
    margin-bottom: 6px;
    border-radius: 50%;
  }

  .card-name {
    width: 100%;
    min-height: 32px;
    margin-bottom: 7px;
    color: ${props =>
      props.$colorType === 'black' ? '#fff' : props.$textColor || '#000'};
  }

  .desc {
    margin-bottom: 2px;
    color: ${props => props.$textColor || '#999'};
  }

  .amount {
    color: ${props =>
      props.$colorType === 'black' ? '#fff' : props.$textColor || '#000'};
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      height: ${mixin.pxToVw('124')};
      padding: ${mixin.pxToVw('14 16')};
    }

    .card-img {
      width: ${mixin.pxToVw('15')};
      min-height: ${mixin.pxToVw('15')};
      margin-bottom: ${mixin.pxToVw('6')};
    }

    .card-name {
      min-height: ${mixin.pxToVw('32')};
      margin-bottom: ${mixin.pxToVw('7')};
    }

    .desc {
      margin-bottom: ${mixin.pxToVw('2')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .btn {
      height: 120px;
      padding: 24px 30px;
    }

    .card-img {
      position: absolute;
      top: 24px;
      left: 30px;
      margin: 0;
    }

    .card-name {
      min-height: auto;
      font-size: 15px;
      line-height: 16px;
      margin-bottom: 18px;
      padding-left: 21px;
    }

    .desc {
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 4px;
    }

    .amount {
      font-size: 18px;
    }
  }
`;
